import { ISubmitResponse } from '@interfaces/models/ISubmitResponse';
import { VgEmploymentState } from '@interfaces/models/open-account-mfes/employment-mfe.model';
import { ValidationStatus } from '@interfaces/models/open-account-mfes/mfe-common.interfaces';
import { SettlementFundAoAEnum } from '@interfaces/settlement-fund/settlement-fund.enum';
import { createAction, props } from '@ngrx/store';

export const validateOpenAccount = createAction('[Open Account] Validate open account');

export const validateOpenAccountResponse = createAction(
  '[Open Account] Open account response',
  props<{ payload: boolean }>(),
);

export const validateOpenAccountFailure = createAction(
  '[Open Account] Validate open account failure',
);

export const submitOpenAccount = createAction('[Open Account] Submit open account');

export const submitOpenAccountComplete = createAction(
  '[Open Account] Submit open account complete',
);

export const submitOpenAccountResponse = createAction(
  '[Open Account] Submit open account response',
  props<{ payload: ISubmitResponse }>(),
);
export const submitOpenAccountFailure = createAction('[Open Account] Submit open account failure');

export const updateSettlementFundChoice = createAction(
  '[Open Account] Update Settlement Fund Response',
  props<{ payload: SettlementFundAoAEnum }>(),
);

export const setIsEditingProfile = createAction(
  '[Open Account] Set Is Editing Profile',
  props<{ isEditing: boolean }>(),
);

export const setIsEditingEmployment = createAction(
  '[Open Account] Set Is Editing Employment',
  props<{ isEditing: boolean }>(),
);

export const setIsEditingAccount = createAction(
  '[Open Account] Set Is Editing Account',
  props<{ isEditing: boolean }>(),
);

export const updateEmploymentMfeData = createAction(
  '[Open Account] Update Employment MFE Data',
  props<{
    ownerIndex: number;
    employment: Partial<VgEmploymentState>;
  }>(),
);

export const updateEmploymentMfeValidationStatus = createAction(
  '[Open Account] Update Employment MFE Validation Status',
  props<{
    ownerIndex: number;
    validationStatus: ValidationStatus;
  }>(),
);

export const clearEmploymentMfeData = createAction(
  '[Open Account] Clear Employment MFE Data',
  props<{ ownerIndex?: number }>(),
);

export const clearOpenAccountState = createAction('[Open Account] Clear');
